export const readFileAsDataUrl = async (file: File) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = e => {
            const data = reader.result;
            resolve(data);
        };

        reader.readAsDataURL(file);
    });
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/helpers/file.ts